export const users = [
  {
    fullName: "Abdulkarim Chukkol",
    email: "admin@sas.com",
    phoneNumber: "08067897865",
    type: "Admin",
    role: "admin",
    status: "active",
    profileImg: "",
  },
  {
    fullName: "Sylvanus Tahir (SAN)",
    email: "staff@sas.com",
    phoneNumber: "09087651245",
    role: "staff",
    type: "Staff",
    status: "active",
  },
  {
    fullName: "Chinwe Ndubeze",
    email: "dev@sas.com",
    phoneNumber: "07089765431",
    type: "Software Developer",
    role: "dev",
    status: "active",
    profileImg: "",
  },
];

export const roles = [
  {
    role: "Super Admin",
    noOfUsers: 1,
    dateCreated: "06/08/2023",
  },
  {
    role: "Chairman",
    noOfUsers: 1,
    dateCreated: "06/08/2023",
  },
  {
    role: "Director Legal",
    noOfUsers: 1,
    dateCreated: "06/08/2023",
  },
];

export const departments = [
  {
    deptName: "Legal Department",
    members: "2",
    status: "active",
  },
];

export const cases = [
  {
    caseTitle: "FRN vs Rotimi Praise",
    caseType: "Criminal Case",
    legalOfficer: "Amadu Uche",
    dateCreated: "06/04/2023",
    status: "Legal Advice",
  },
  {
    caseTitle: "FRN vs Uchechukwu Bassey",
    caseType: "Criminal Case",
    legalOfficer: "Ibrahim Bala",
    dateCreated: "06/04/2023",
    status: "Case in Appeal Court",
  },
  {
    caseTitle: "FRN vs Fraily Wales",
    caseType: "Criminal Case",
    legalOfficer: "Korede Lawal",
    dateCreated: "06/04/2023",
    status: "Case in Supreme Court",
  },
  {
    caseTitle: "FRN vs Bosede Ajibade",
    caseType: "Criminal Case",
    legalOfficer: "Ibrahim Bala",
    dateCreated: "06/04/2023",
    status: "Legal Advice",
  },
  {
    caseTitle: "FRN vs Babalola Bablor",
    caseType: "Criminal Case",
    legalOfficer: "Amadu Uche",
    dateCreated: "06/04/2023",
    status: "Judgement",
  },
  {
    caseTitle: "FRN vs Noah Hilton",
    caseType: "Criminal Case",
    legalOfficer: "Korede Lawal",
    dateCreated: "06/04/2023",
    status: "Judgement",
  },
  {
    caseTitle: "FRN vs malor Williams",
    caseType: "Criminal Case",
    legalOfficer: "Amadu Uche",
    dateCreated: "06/04/2023",
    status: "Case in Federal High Court",
  },
  {
    caseTitle: "FRN vs FistoMiss Dhris",
    caseType: "Criminal Case",
    legalOfficer: "Ibrahim Bala",
    dateCreated: "06/04/2023",
    status: "Case in Appeal Court",
  },
  {
    caseTitle: "FRN vs Okenne Bikrun",
    caseType: "Criminal Case",
    legalOfficer: "Ibrahim Bala",
    dateCreated: "06/04/2023",
    status: "Case in Appeal Court",
  },
  {
    caseTitle: "FRN vs Montori James",
    caseType: "Criminal Case",
    legalOfficer: "Ibrahim Bala",
    dateCreated: "06/04/2023",
    status: "Case in State High Court",
  },
];

export const profileData = [
  {
    DateTime: "Mar 12, 2023, 12:15 PM",
    Activity: "You viewed dashboard",
  },
  {
    DateTime: "Mar 12, 2023, 12:15 PM",
    Activity: "You viewed dashboard",
  },
  {
    DateTime: "Mar 12, 2023, 12:15 PM",
    Activity: "You viewed dashboard",
  },

  {
    DateTime: "Mar 12, 2023, 12:15 PM",
    Activity: "You viewed dashboard",
  },
  {
    DateTime: "Mar 12, 2023, 12:15 PM",
    Activity: "You viewed dashboard",
  },
  {
    DateTime: "Mar 12, 2023, 12:15 PM",
    Activity: "You viewed dashboard",
  },
];

export const notificationData = [
  {
    title: "New project created by John Kent - EFCC",
    projectType: "Customer Request",
    time: "just now",
  },
  {
    title: "New project created by John Kent - EFCC",
    projectType: "Customer Request",
    time: "5 minutes ago",
  },
  {
    title: "New project created by John Kent - EFCC",
    projectType: "Customer Request",
    time: "7 minutes ago",
  },
  {
    title: "New project created by John Kent - EFCC",
    projectType: "Customer Request",
    time: "9 minutes ago",
  },
];

export const newProjectData = [
  {
    ProjectName: " EFCC",
    StartDate: "23-08-2023",
    EndDate: "23-10-2023",
    projectReferenceCode: "EFCC/001 v.2",
    developersAssigned: [
      "Warris Olaniyi",
      "Damilola Abiona",
      "Kenneth Chukuma",
      "Abdullateef Odufeso",
    ],
    developersReassigned_Removed: ["Warris Olaniyi", "Damilola Abiona"],
    status: "active",
  },
  {
    ProjectName: " Scholaroom",
    StartDate: "23-08-2023",
    EndDate: "23-10-2023",
    projectReferenceCode: "SCH / 001",
    developersAssigned: [
      "Warris Olaniyi",
      "Damilola Abiona",
      "Kenneth Chukuma",
      "Abdullateef Odufeso",
    ],
    developersReassigned_Removed: ["Warris Olaniyi", "Damilola Abiona"],
    status: "inactive",
  },
  {
    ProjectName: "PMS",
    StartDate: "23-08-2023",
    EndDate: "23-10-2023",
    projectReferenceCode: "PMS / 001.v1",
    developersAssigned: [
      "Warris Olaniyi",
      "Damilola Abiona",
      "Kenneth Chukuma",
      "Abdullateef Odufeso",
    ],
    developersReassigned_Removed: ["Warris Olaniyi", "Damilola Abiona"],
    status: "completed",
  },
  {
    ProjectName: " Support App",
    StartDate: "23-08-2023",
    EndDate: "23-10-2023",
    projectReferenceCode: "SAS/001 ",
    developersAssigned: [
      "Warris Olaniyi",
      "Damilola Abiona",
      "Kenneth Chukuma",
      "Abdullateef Odufeso",
    ],
    developersReassigned_Removed: ["Warris Olaniyi", "Damilola Abiona"],
    status: "active",
  },
  {
    ProjectName: " DVLA",
    StartDate: "23-08-2023",
    EndDate: "23-10-2023",
    projectReferenceCode: "DVLA / 001.v1",
    developersAssigned: [
      "Warris Olaniyi",
      "Damilola Abiona",
      "Kenneth Chukuma",
      "Abdullateef Odufeso",
    ],
    developersReassigned_Removed: ["Warris Olaniyi", "Damilola Abiona"],
    status: "inactive",
  },
];

export const recentActivityData = [
  {
    date: "21-08-2023",
    activityType: "New Project Created",
    activityDetails: "Project Name: EFCC",
    status: "active",
  },
  {
    date: "21-08-2023",
    activityType: "New Project Created",
    activityDetails: "Project Name: EFCC",
    status: "active",
  },
  {
    date: "21-08-2023",
    activityType: "New Project Created",
    activityDetails: "Project Name: EFCC",
    status: "active",
  },
  {
    date: "21-08-2023",
    activityType: "New Project Created",
    activityDetails: "Project Name: EFCC",
    status: "active",
  },
  {
    date: "21-08-2023",
    activityType: "New Project Created",
    activityDetails: "Project Name: EFCC",
    status: "active",
  },
  {
    date: "21-08-2023",
    activityType: "New Project Created",
    activityDetails: "Project Name: EFCC",
    status: "active",
  },
  {
    date: "21-08-2023",
    activityType: "New Project Created",
    activityDetails: "Project Name: EFCC",
    status: "active",
  },
  {
    date: "21-08-2023",
    activityType: "New Project Created",
    activityDetails: "Project Name: EFCC",
    status: "active",
  },
  {
    date: "21-08-2023",
    activityType: "New Project Created",
    activityDetails: "Project Name: EFCC",
    status: "active",
  },
];

export const roleManagementData = [
  {
    roleName: "Head of Department",
    roleDescription: "Manage all Support",
    department: "Technology",
    dateCreated: "23-08-2023",
    privileges: "Assign Privileges",
    status: "active",
  },
  {
    roleName: "Head of Department",
    roleDescription: "Manage all Support",
    department: "Technology",
    dateCreated: "23-08-2023",
    privileges: "Assign Privileges",
    status: "active",
  },
  {
    roleName: "Head of Department",
    roleDescription: "Manage all Support",
    department: "Technology",
    dateCreated: "23-08-2023",
    privileges: "Assign Privileges",
    status: "active",
  },
  {
    roleName: "Head of Department",
    roleDescription: "Manage all Support",
    department: "Technology",
    dateCreated: "23-08-2023",
    privileges: "Assign Privileges",
    status: "active",
  },
  {
    roleName: "Head of Department",
    roleDescription: "Manage all Support",
    department: "Technology",
    dateCreated: "23-08-2023",
    privileges: "Assign Privileges",
    status: "active",
  },
  {
    roleName: "Head of Department",
    roleDescription: "Manage all Support",
    department: "Technology",
    dateCreated: "23-08-2023",
    privileges: "Assign Privileges",
    status: "active",
  },
  {
    roleName: "Head of Department",
    roleDescription: "Manage all Support",
    department: "Technology",
    dateCreated: "23-08-2023",
    privileges: "Assign Privileges",
    status: "active",
  },
];
export const userManagementData = [
  {
    name: "Chuma Chibu",
    role: "Developer",
    email: "chuma@gmail.com",
    status: "active",
  },
];

export const recentUpdateData = [
  {
    SopTitle: "How to Start New Registration",
    DateTime: "23-08-2023 12:15pm",
    NameOfDeveloper: "Warris Olaniyi",
    UpdateSummary: "Completed phase 1 of development",
  },
  {
    SopTitle: "How to End Registration",
    DateTime: "23-08-2023 12:15pm",
    NameOfDeveloper: "Damilola Abiona",
    UpdateSummary: "Completed phase 1 of development",
  },
  {
    SopTitle: "Walk-in Registration",
    DateTime: "23-08-2023 12:15pm",
    NameOfDeveloper: "Warris Olaniyi",
    UpdateSummary: "Completed phase 1 of development",
  },

  {
    SopTitle: "How to End Registration",
    DateTime: "23-08-2023 12:15pm",
    NameOfDeveloper: "Damilola Abiona",
    UpdateSummary: "Completed phase 1 of development",
  },
];

export const documentInputData = [
  {
    DateTime: "23-08-2023 12:15pm",
    InputBy: "Isioma Akuabata",
    DocumentType: "BRS.com",
  },
  {
    DateTime: "23-08-2023 12:15pm",
    InputBy: "Adeola- Yomi Patrick",
    DocumentType: "Manual Product.com",
  },
  {
    DateTime: "23-08-2023 12:15pm",
    InputBy: "Isioma Akuabata",
    DocumentType: "BRS.com",
  },
  {
    DateTime: "23-08-2023 12:15pm",
    InputBy: "Adeola- Yomi Patrick",
    DocumentType: "Manual Product.com",
  },
];

export const auditLogData = [
  {
    DateTime: "23-08-2023 12:15pm",
    Username: "Isioma Akuabata",
    Action: "Opened Bussiness Requirement Specification Document",
  },
  {
    DateTime: "23-08-2023 12:15pm",
    Username: "Adeola- Yomi Patrick",
    Action: "John Doe was removed from EFCC project",
  },
  {
    DateTime: "23-08-2023 12:15pm",
    Username: "Adeola- Yomi Patrick",
    Action: "Changed Warris fron Team Lead",
  },
  {
    DateTime: "23-08-2023 12:15pm",
    Username: "Isioma Akuabata",
    Action: "Opened Bussiness Requirement Specification Document",
  },
];

export const avatars = [
  { name: "Gbemileke Daniel", title: "Software Engineer" },
  { name: "Opeyemi Alabi", title: " UI/UX Designer" },
  { name: "Ibrahim Olayioye", title: "Software Developer" },
  { name: "Warris Olaniyi", title: "Software Developer Intern" },
  { name: "Fredrick Chukuma", title: "UI/UX Designer Intern" },
  { name: "Damilola Abiona", title: "Front-End Developer Intern" },
];

export const createProjectData = [
  {
    id:'1',
    ProjectRefCode: "WRV / 001 v.2",
    ProjectName: "Waec Revision System",
    LOB: "Examination Body",
    clientName: "Waec Nigeria",
    productManager: "John Doe",
    TeamLead: "Warris Olaniyi",
    SupportDate: "23-08-2023",
    StartDate: "23-08-2023",
    EndDate: "23-10-2023",
  },
  {
    id:'2',
    ProjectRefCode: "DVLA / 001 v.2",
    ProjectName: "DVLA",
    LOB: "Examination Body",
    clientName: "Waec Nigeria",
    productManager: "John Doe",
    TeamLead: "Warris Olaniyi",
    SupportDate: "23-08-2023",
    StartDate: "23-08-2023",
    EndDate: "23-10-2023",
  },
  {
    id:'3',
    ProjectRefCode: "SCH / 001 v.2",
    ProjectName: "Scholaroom",
    LOB: "Examination Body",
    clientName: "Waec Nigeria",
    productManager: "John Doe",
    TeamLead: "Warris Olaniyi",
    SupportDate: "23-08-2023",
    StartDate: "23-08-2023",
    EndDate: "23-10-2023",
  },
  {
    id:'4',
    ProjectRefCode: "EPC / 001 v.2",
    ProjectName: "E-Procurement",
    LOB: "Examination Body",
    clientName: "Waec Nigeria",
    productManager: "John Doe",
    TeamLead: "Warris Olaniyi",
    SupportDate: "23-08-2023",
    StartDate: "23-08-2023",
    EndDate: "23-10-2023",
  },
  {
    id:'5',
    ProjectRefCode: "EFCC / 001 v.2",
    ProjectName: "EFCC",
    LOB: "Examination Body",
    clientName: "Waec Nigeria",
    productManager: "John Doe",
    TeamLead: "Warris Olaniyi",
    SupportDate: "23-08-2023",
    StartDate: "23-08-2023",
    EndDate: "23-10-2023",
  },
];

export const revHistoryData = [
  {
    date: "23-08-2023",
    name: "Victor Olugwu",
    descriptionofchange: "Added new section on super admin module ",
  },
  {
    date: "23-08-2023",
    name: "Victor Olugwu",
    descriptionofchange: "Added new section on super admin module ",
  },
  {
    date: "23-08-2023",
    name: "Victor Olugwu",
    descriptionofchange: "Added new section on super admin module ",
  },
  {
    date: "23-08-2023",
    name: "Victor Olugwu",
    descriptionofchange: "Added new section on super admin module ",
  },
];

export const manageClientData = [
  {
    date: "22-07-23",
    nameOfClient: "WAEC Nigeria",
    lineOfBusiness: "Examination Body",
    contactPerson: "John Doe",
    emailAddress: "waecnigeria@gmail.com",
    phoneNumber: "+2348034567000",
  },
  {
    date: "22-07-23",
    nameOfClient: "WAEC Nigeria",
    lineOfBusiness: "Examination Body",
    contactPerson: "John Doe",
    emailAddress: "waecnigeria@gmail.com",
    phoneNumber: "+2348034567000",
  },
  {
    date: "22-07-23",
    nameOfClient: "WAEC Nigeria",
    lineOfBusiness: "Examination Body",
    contactPerson: "John Doe",
    emailAddress: "waecnigeria@gmail.com",
    phoneNumber: "+2348034567000",
  },
  {
    date: "22-07-23",
    nameOfClient: "WAEC Nigeria",
    lineOfBusiness: "Examination Body",
    contactPerson: "John Doe",
    emailAddress: "waecnigeria@gmail.com",
    phoneNumber: "+2348034567000",
  },
  {
    date: "22-07-23",
    nameOfClient: "WAEC Nigeria",
    lineOfBusiness: "Examination Body",
    contactPerson: "John Doe",
    emailAddress: "waecnigeria@gmail.com",
    phoneNumber: "+2348034567000",
  },
  {
    date: "22-07-23",
    nameOfClient: "WAEC Nigeria",
    lineOfBusiness: "Examination Body",
    contactPerson: "John Doe",
    emailAddress: "waecnigeria@gmail.com",
    phoneNumber: "+2348034567000",
  },
];

export const adminLineOfBusinessData = [
  {
    date: "22-07-23",
    lineOfBusiness: "Examination Body",
    description: "Support projects related to education course",
    creator: "John Doe",
  },
  {
    date: "22-07-23",
    lineOfBusiness: "Examination Body",
    description: "Support projects related to education course",
    creator: "John Doe",
  },
  {
    date: "22-07-23",
    lineOfBusiness: "Examination Body",
    description: "Support projects related to education course",
    creator: "John Doe",
  },
  {
    date: "22-07-23",
    lineOfBusiness: "Examination Body",
    description: "Support projects related to education course",
    creator: "John Doe",
  },
  {
    date: "22-07-23",
    lineOfBusiness: "Examination Body",
    description: "Support projects related to education course",
    creator: "John Doe",
  },
  {
    date: "22-07-23",
    lineOfBusiness: "Examination Body",
    description: "Support projects related to education course",
    creator: "John Doe",
  },
];

export const DevSopProjectData = [
  {
    SOPTitle: "Starting Registration",
    createdby: "Warris Olaniyi",
    datecreated: "23-08-2023",
    sopLink: "Starting Registraion 1.0",
    updatedBy: "Nenty Obasi",
    lastModified: "23-08-2023",
  },
  {
    SOPTitle: "Starting Registration",
    createdby: "Warris Olaniyi",
    datecreated: "23-08-2023",
    sopLink: "Starting Registraion 1.0",
    updatedBy: "Nenty Obasi",
    lastModified: "23-08-2023",
  },
  {
    SOPTitle: "Starting Registration",
    createdby: "Warris Olaniyi",
    datecreated: "23-08-2023",
    sopLink: "Starting Registraion 1.0",
    updatedBy: "Nenty Obasi",
    lastModified: "23-08-2023",
  },
  {
    SOPTitle: "Starting Registration",
    createdby: "Warris Olaniyi",
    datecreated: "23-08-2023",
    sopLink: "Starting Registraion 1.0",
    updatedBy: "Nenty Obasi",
    lastModified: "23-08-2023",
  },
];

export const staffLineOfBusinessData = [
  {
    date: "22-07-23",
    lineOfBusiness: "Examination Body",
    description: "Support projects related to education course",
    creator: "John Doe",
    projects: 4,
    sop: 8,
  },
  {
    date: "22-07-23",
    lineOfBusiness: "Examination Body",
    description: "Support projects related to education course",
    creator: "John Doe",
    projects: 4,
    sop: 8,
  },
  {
    date: "22-07-23",
    lineOfBusiness: "Examination Body",
    description: "Support projects related to education course",
    creator: "John Doe",
    projects: 4,
    sop: 8,
  },
];

export const DevrevHistoryData = [
  {
    Soptitle: "Starting Registration",
    dateTime: "24-08-2023,  12:15pm",
    action: "Added database connection settings ",
  },
  {
    Soptitle: "Starting Registration",
    dateTime: "24-08-2023,  12:15pm",
    action: "Added database connection settings ",
  },
  {
    Soptitle: "Starting Registration",
    dateTime: "24-08-2023,  12:15pm",
    action: "Added database connection settings ",
  },
  {
    Soptitle: "Starting Registration",
    dateTime: "24-08-2023,  12:15pm",
    action: "Added database connection settings ",
  },
];

export const LOBProjectsData = [
  {
    refCode: "SCHM /oo1 v.1",
    projectName: "Vatebra Academy",
    projectType: "New Project",
  },
  {
    refCode: "SCHM /oo1 v.1",
    projectName: "Vatebra Academy",
    projectType: "New Project",
  },
  {
    refCode: "SCHM /oo1 v.1",
    projectName: "Vatebra Academy",
    projectType: "New Project",
  },
];

export const LOBSOPsData = [
  {
    title: "Project Workflow",
    createdBy: "John Doe",
    date: "23-08-2023",
  },
  {
    title: "Project Workflow",
    createdBy: "John Doe",
    date: "23-08-2023",
  },
  {
    title: "Project Workflow",
    createdBy: "John Doe",
    date: "23-08-2023",
  },
];
